module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy S10+ Prism Blue.b71a9606.png";